<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="height: auto;margin-top: -45vh;min-height: 90vh">
                <div v-if="confirmPurchase" class="dialog-body-confirm">
                    <div class="dialog-title">
                        <span v-if="(isTrial() && (purchasePlanType == 0))" v-t="'message.title_purchase_from_trial'"></span>
                        <span v-else-if="isTrial()"><span v-t="'message.title_purchase_new'"></span>（{{ getPurchasePlanName() }})</span>
                        <span v-else v-t="'message.title_purchase_new'"></span>
                    </div>
                    <hr class="dialog-hr">
                    <div id="dialog-body" class="dialog-body" style="height: calc(90vh - 160px)">
                        <div v-if="purchasePlanType == 0">
                            <confirmlicense :appData="appData"
                                            :licenseInfo="inputForm.license"
                                            :purchasePeriodType="Number(inputForm.purchasePeriodType)"
                                            :purchaseAmount="getPurchaseAmountTotal(inputForm.purchasePeriodType)"
                                            :confirmType=0
                                            :disablePurchasingOption="disablePurchasingOption"
                                            :currencyYen="currencyYen">
                            </confirmlicense>
                            </div>
                        <div v-else>
                            <ConfirmLicenseForPlanPurchasing :appData="appData"
                                            :licenseInfo="inputForm.license.numberLicense[0]"
                                            :purchasePeriodType="Number(inputForm.purchasePeriodType)"
                                            :confirmType=0
                                            :planType=null
                                            :newPlanType="purchasePlanType"
                                            :priceOfPlan=null
                                            :priceNewPlan="priceOfPlan"
                                            :currencyYen="currencyYen">
                            </ConfirmLicenseForPlanPurchasing>
                        </div>
                        <hr class="dialog-hr">
                        <div class="license-item-value" style="text-align: center">
                            <span v-t="'message.item_purchase_amount'"/>
                            <span class="total-amount">{{ getDisplayAmountValue(getPurchaseAmountTotal(inputForm.purchasePeriodType)) }}</span>
                            <span v-if="currencyYen" v-t="'message.unit_currency2'"/>
                            <span v-else>USD</span>
                        </div>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" @click="confirmCancel()" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" @click="purchaseLicense()">OK</el-button>
                    </div>
                </div>
                <div v-else>
                    <div class="dialog-title">
                        <span v-if="(isTrial() && (purchasePlanType == 0))" v-t="'message.title_purchase_from_trial'"></span>
                        <span v-else-if="isTrial()"><span v-t="'message.title_purchase_new'"></span>（{{ getPurchasePlanName() }})</span>
                        <span v-else v-t="'message.title_purchase_new'"></span>
                    </div>
                    <hr class="dialog-hr">
                    <div id="dialog-body" class="dialog-body">
                        <div v-if="purchasePlanType == 0">
                            <div class="dialog-description">
                                <span v-t="'message.title_input_purchase_info'"/><br>
                                <span v-if="isTrial()" style="color: #d55169;" v-t="'message.hint_purchase_note3'">
                                </span>
                                <span v-else style="color: #d55169;" v-t="'message.hint_purchase_note2'">
                                </span><br>
                                <a href="javascript:void(0);" style="text-decoration:none" @click="$emit('edituser')">
                                    <span v-t="'message.info_guide_to_delete_user'"/>
                                </a>
                            </div>
                            <el-form :model="inputForm" ref="inputForm" label-width="220px" class="inputform">
                                <div class="dialog-form-item">
                                    <table width=100%>
                                        <tr class="license-record-header">
                                            <td colspan="4" class="license-item-title" v-t="'message.item_contract_type'">
                                            </td>
                                        </tr>
                                        <tr class="license-record">
                                            <td colspan="4" class="license-item-value" style="text-align: left" >
                                            <el-tooltip class="item" effect="dark" placement="top-start">
                                                <div slot="content"><span v-t="'message.hint_purchase_note_monthly1'"/></div>
                                                <el-radio v-model="inputForm.purchasePeriodType" label="0" >{{ getPurchasePeriodTypeName(0) }}</el-radio>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark"  placement="top-start">
                                                <div slot="content"><span v-html="$t('message.hint_purchase_note_yearly1')"/></div>
                                                <el-radio v-model="inputForm.purchasePeriodType" label="1" >{{ getPurchasePeriodTypeName(1) }}</el-radio>
                                            </el-tooltip>
                                            </td>
                                        </tr>
                                        <tr class="license-record-header">
                                            <td class="license-item-title" style="width: 30%" v-t="'message.item_license_basic'">
                                            </td>
                                            <td class="license-item-title" style="text-align:right;width: 30%" v-t="'message.item_purchase_count'">
                                            </td>
                                            <td colspan="2" class="license-item-title" style="text-align: right;padding-right:10px" v-t="'message.item_purchase_amount'">
                                            </td>
                                        <tr>
                                        <tr v-for="(license , index) in inputForm.license.numberLicense" :class="{'license-record': (index<inputForm.license.numberLicense.length-1),'license-record-bottom': (index==inputForm.license.numberLicense.length-1)}">
                                            <td class="license-item-value">
                                                {{ license.displayName}}
                                            </td>
                                            <td v-if="license.type == 1" class="license-item-value" style="text-align: right">
                                                <el-input-number v-model="license.newValue" :min="license.current" @change="changeNumberLicense(index)"></el-input-number>
                                            </td>
                                            <td v-else-if="license.type == 2"  class="license-item-value" style="text-align: right">
                                                <el-input-number v-model="license.newValue" :min="0" :max="inputForm.license.numberLicense[0].newValue" :disabled=license.disabled @change="changeNumberLicense(index)"></el-input-number>
                                            </td>
                                            <td v-else-if="license.type == 3" class="license-item-value" style="text-align: right">
                                                <el-input-number v-model="license.newValue" :min="0" :max="inputForm.license.numberLicense[1].newValue" :disabled=license.disabled @change="changeNumberLicense(index)"></el-input-number>
                                            </td>
                                            <td v-else-if="license.type == 4" class="license-item-value" style="text-align: right">
                                                <el-input-number v-model="license.newValue" :min="0" :max="inputForm.license.numberLicense[0].newValue" :step="inputForm.license.numberLicense[0].newValue" :disabled=license.disabled @change="changeNumberLicense(index)"></el-input-number>
                                            </td>
                                            <td v-else-if="license.type == 5" class="license-item-value" style="text-align: right">
                                                <el-input-number v-model="license.newValue" :min="0" :max="1" :step=license.unit :disabled=license.disabled @change="changeNumberLicense(index)"></el-input-number>
                                            </td>
                                            <td v-if="inputForm.purchasePeriodType == 0" colspan="2" class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                                                {{ getDisplayAmountValue(license.purchaseMonthlyAmount) }}
                                            </td>
                                            <td v-else  colspan="2" class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                                                {{ getDisplayAmountValue(license.purchaseYearlyAmount) }}
                                            </td>
                                        </tr>
                                        <hr class="transparent-hr">
                                        <tr class="license-record-header">
                                            <td class="license-item-title" style="width: 30%" v-t="'message.item_license_recurring'">
                                            </td>
                                            <td class="license-item-title" style="text-align:right;width: 15%;padding-right:25px" v-t="'message.item_purchase_count'">
                                            </td>
                                            <td class="license-item-title" style="text-align:right;width: 15%;padding-right:25px">
                                            </td>
                                            <td class="license-item-title" style="text-align: right;padding-right:10px" v-t="'message.item_purchase_amount'">
                                            </td>
                                        <tr>
                                        <tr v-for="(license , index) in inputForm.license.usageLicense" :class="{'license-record': (index<inputForm.license.usageLicense.length-1),'license-record-bottom': (index==inputForm.license.usageLicense.length-1)}">
                                            <td class="license-item-value">
                                                {{ license.displayName}}
                                                <el-tooltip effect="dark" placement="right">
                                                    <div v-if="license.type==100" slot="content" style="text-align:left" v-html="$t('message.hint_purchase_hint_speech')">
                                                    </div>
                                                    <div v-else-if="license.type==101" slot="content" style="text-align:left" v-html="$t('message.hint_purchase_hint_translation')">
                                                    </div>
                                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                                </el-tooltip>
                                            </td>
                                            <td class="license-item-value" style="text-align: right">
                                                <el-input-number v-model="license.newCount" :min="0" :disabled="license.disabled" @change="changeUsageLicense(index)" label="label"></el-input-number>
                                            </td>
                                            <td class="license-item-value" style="text-align: left">
                                                ({{ license.newValue.toLocaleString()  }} {{ getUnitName(license.type) }})
                                            </td>
                                            <td v-if="inputForm.purchasePeriodType == 0" class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                                                {{ getDisplayAmountValue(license.purchaseMonthlyAmount) }}
                                            </td>
                                            <td v-else class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                                                {{ getDisplayAmountValue(license.purchaseYearlyAmount) }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </el-form>
                        </div>
                        <div v-else>
                            <!---- purchasing plan ------>
                            <div class="dialog-description">
                                <span v-t="'message.title_input_purchase_info'"/><br>
                                <span v-if="isTrial()" style="color: #d55169;" v-t="'message.hint_purchase_note3'">
                                </span>
                                <span v-else style="color: #d55169;" v-t="'message.hint_purchase_note2'">
                                </span><br>
                                <a href="javascript:void(0);" style="text-decoration:none" @click="$emit('edituser')">
                                    <span v-t="'message.info_guide_to_delete_user'"/>
                                </a>
                            </div>
                            <el-form :model="inputForm" ref="inputForm" label-width="220px" class="inputform">
                                <div class="dialog-form-item">
                                    <table width=100%>
                                        <tr class="license-record-header">
                                            <td colspan="3" class="license-item-title" v-t="'message.item_contract_type'">
                                            </td>
                                        </tr>
                                        <tr class="license-record-no-hover">
                                            <td colspan="3" class="license-item-value" style="text-align: left" >
                                                <el-tooltip class="item" effect="dark" placement="top-start">
                                                    <div slot="content"><span v-t="'message.hint_purchase_note_monthly1'"/></div>
                                                    <el-radio v-model="inputForm.purchasePeriodType" label="0" >{{ getPurchasePeriodTypeName(0) }}</el-radio>
                                                </el-tooltip>
                                                <el-tooltip class="item" effect="dark"  placement="top-start">
                                                    <div slot="content"><span v-html="$t('message.hint_purchase_note_yearly1')"/></div>
                                                    <el-radio v-model="inputForm.purchasePeriodType" label="1" >{{ getPurchasePeriodTypeName(1) }}</el-radio>
                                                </el-tooltip>
                                            </td>
                                        </tr>
                                        <tr class="license-record-header">
                                            <td class="license-item-title" style="width: 30%">プラン名
                                            </td>
                                            <td class="license-item-title" style="text-align:right;width: 30%" v-t="'message.item_purchase_count'">
                                            </td>
                                            <td class="license-item-title" style="text-align: right;padding-right:10px" v-t="'message.item_purchase_amount'">
                                            </td>
                                        <tr>
                                        <tr class="license-record-no-hover-bottom">
                                            <td class="license-item-value">
                                                {{ getPurchasePlanName() }}
                                            </td>
                                            <td class="license-item-value" style="text-align: right">
                                                <el-input-number v-model="inputForm.license.numberLicense[0].newValue" :min="Math.max(inputForm.license.numberLicense[0].current, 1)" @change="changeNumberLicense(0)"></el-input-number>
                                            </td>
                                            <td class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                                                {{ getDisplayAmountValue(getPurchasePlanAmount()) }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </el-form>
                        </div>
                        <table id="paymentMethod">
                            <tr class="license-record-header">
                                <td colspan="3" class="license-item-title" style="width: 30%">
                                    <span v-t="'message.item_payment_method'"/>
                                </td>
                            <tr>
                            <tr class="license-record-no-hover-bottom">
                                <td colspan="3" class="license-item-value" style="text-align: left" >
                                    <el-radio-group v-model="inputForm.billingType" @change="handleChangeBillingType">
                                        <el-tooltip class="item" effect="dark" placement="top-start">
                                            <div slot="content"><span v-html="$t('message.hint_purchase_credit_card')"/></div>
                                            <el-radio label="1"><span v-t="'message.item_billing_credit_card'"/></el-radio>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark"  placement="top-start">
                                            <div slot="content"><span v-html="$t('message.hint_purchase_paid')"/></div>
                                            <el-radio label="3"><span v-t="'message.item_payment_paid'"/></el-radio>
                                        </el-tooltip>
                                    </el-radio-group>
                                </td>
                            </tr>
                            <tr v-if="Number(inputForm.billingType) === Const.BILLING_PAID" class="license-record-no-hover-bottom">
                                <td colspa="3" class="item-value" style="text-align: left;padding: 0px 0px 20px 20px" >
                                    <div v-if="paidMemberStatus === Const.PAID_STATUS_NOT_FOUND">
                                        <span v-if="paidMemberStatus === Const.PAID_STATUS_NOT_FOUND" v-html="$t('message.desc_paid_new')"/><br>
                                        <el-checkbox class="paid-confirm" v-model="checkPaid" style="color:#d55169;">
                                            <span v-html="$t('message.desc_agree_to_paid')"/>
                                        </el-checkbox>
                                    </div>
                                    <div v-else style="padding-left:25px" v-html="$t('message.desc_paid_exist')"/>
                                </td>
                            </tr>
                            <tr v-if="isCreditPayment() || ((isPaidPayment()) && (paidMemberStatus === Const.PAID_STATUS_NOT_FOUND))" class="license-record-no-hover-bottom">
                                <td colspan="3" align="center" style="background-color:#f6f6f6">
                                    <div v-if="isCreditPayment()" class="credit-card-box">
                                        <creditcardinput ref="creditCardInput" :definedCardNumber="cardNumber" :definedExpiredDate="cardExpire" :definedHolderName="cardHolderName"
                                                         :gmoSeverScriptPath="appData.gmoSeverScriptPath" :gmoShopId="appData.gmoShopId" :currencyYen="currencyYen"
                                                         @on-change-input="handleChangeInput" @saveComplete="saveCardComplete">
                                        </creditcardinput>
                                    </div>
                                    <div v-else>
                                        <div style="padding: 20px 0px 10px 0px;font-weight: bold;font-size: 16px;">
                                            <span v-t="'message.title_input_paid_info'"/>
                                        </div>
                                        <PaidInfoInput ref="paidInfoInput" :paidInformation="inputForm.paidInformation">
                                        </PaidInfoInput>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr class="dialog-hr">
                    <div class="license-item-value" style="text-align: center">
                        <span  v-t="'message.item_purchase_amount'"/>
                        <span v-if="purchasePlanType == 0" class="total-amount">{{ getDisplayAmountValue(getPurchaseAmountTotal(inputForm.purchasePeriodType)) }}</span>
                        <span v-else class="total-amount">{{ getDisplayAmountValue(getPurchasePlanAmount()) }}</span>
                        <span  v-if="currencyYen" v-t="'message.unit_currency2'"/>
                        <span  v-else>USD</span>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" @click="handlePurchaseConfirm()" v-t="'message.button_purchase'"></el-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "./ServerApi.js";
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import constants from './constants.js';
import CreditCardInput from './CreditCardInput.vue';
import PaidInfoInput from './PaidInfoInput.vue';
import ConfirmLicense from './ConfirmLicense.vue';
import ConfirmLicenseForPlanPurchasing from './ConfirmLicenseForPlanPurchasing.vue';

export default {
    data() {
        return {
            Const: {
                BILLING_CREDIT_CARD: constants.BILLING_CREDIT_CARD,
                BILLING_PAID: constants.BILLING_PAID,
                PAID_STATUS_NOT_FOUND: constants.PAID_STATUS_NOT_FOUND,
            },
            inputForm: {
                purchasePeriodType: "0",
                billingType: "1",
                totalAmount: 0,
                requestType: 1,
                license: {
                    numberLicense: [],
                    usageLicense: [],
                },
                checkPaid: false,
                paidInformation: null,
            },
            cardNumber: "",
            cardExpire: "",
            cardSecurityCode: "",
            cardHolderName: "",
            showAmount: true,
            confirmPurchase: false,
            cardValidation: false,
            creditCardInputComponent: null,
            priceOfPlan: null
        };
    },
    methods: {
        handleChangeInput(cardNumber , cardSecurityCode , cardExpire , cardHolderName , validation) {
            this.cardNumber = cardNumber;
            this.cardSecurityCode = cardSecurityCode;
            this.cardExpire = cardExpire;
            this.cardHolderName = cardHolderName;
            this.cardValidation = validation;
            if (!this.cardValidation) {
                let obj = document.getElementById("dialog-body");
                obj.scrollTop = obj.scrollHeight;
            }
        },
        // check number of license
        changeNumberLicense(index) {
            let license = this.inputForm.license.numberLicense[index];
            this.setNewAmount(license);
            switch(Number(license.type)) {
                case constants.LICENSE_USER:
                    for (let checkLicense of this.inputForm.license.numberLicense) {
                        switch(checkLicense.type) {
                            case constants.LICENSE_SPEECH_TEXT :
                            case constants.LICENSE_TRANSLATION :
                                // enabling input of number license if user license over 1
                                checkLicense.disabled = false;
                                if (checkLicense.newValue > license.newValue) {
                                    checkLicense.newValue = license.newValue;
                                    this.setNewAmount(checkLicense);
                                }
                                break;
                            case constants.LICENSE_CONFIG :
                                if (checkLicense.newValue > 0) {
                                    checkLicense.newValue = license.newValue;
                                    this.setNewAmount(checkLicense);
                                }
                                break;
                            case constants.LICENSE_MAP_TALK :
                                checkLicense.newValue = license.newValue;
                                this.setNewAmount(checkLicense);
                                break;
                            default:
                                break;
                        }
                    }
                    break;
                case constants.LICENSE_SPEECH_TEXT:
                    if (license.newValue == 0) {
                        this.disableRecurringLicense(constants.RECURRING_SPEECH_TEXT);
                        this.disableRecurringLicense(constants.RECURRING_TRANSLATION);
                    } else {
                        this.enableRecurringLicense(constants.RECURRING_SPEECH_TEXT);
                    }
                    let translateLicense = this.inputForm.license.numberLicense.filter(function(item, index){
                        if (item.type == constants.LICENSE_TRANSLATION) return true;
                    });
                    if (license.newValue < translateLicense[0].newValue) {
                        translateLicense[0].newValue = license.newValue;
                        this.setNewAmount(translateLicense[0]);
                    }
                    break;
                case constants.LICENSE_TRANSLATION:
                    if (license.newValue == 0) {
                        this.disableRecurringLicense(constants.RECURRING_TRANSLATION);
                    } else {
                        this.enableRecurringLicense(constants.RECURRING_TRANSLATION);
                    }
                    break;
            }
        },
        // check usage of license
        changeUsageLicense(index) {
            let license = this.inputForm.license.usageLicense[index];
            license.newValue = license.newCount * license.unit
            this.setNewAmount(license);
        },
        enableRecurringLicense(licenseType) {
            for (let license of this.inputForm.license.usageLicense) {
                if (Number(license.type) == licenseType) {
                    license.disabled = false;
                    break;
                }
            }
        },
        disableRecurringLicense(licenseType) {
            for (let license of this.inputForm.license.usageLicense) {
                if (Number(license.type) == licenseType) {
                    // clear , disabled all option license if user license become to 0
                    license.newValue = 0;
                    license.newCount = 0;
                    license.purchaseMonthlyAmount = 0;
                    license.purchaseYearlyAmount = 0;
                    license.disabled = true;
                    break;
                }
            }
        },
        checkUserRegistration() {
            let self = this;
            server.post('/gmopaymentsearchmember'
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    //
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_EXTERNAL_SYSTEM:
                            if (res.data.errorInfo == "E01390002") {
                                self.registerUserToGMOPayment(this.primaryOwner);
                            } else {
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_other_system").replace("{functionName}","checkUserRegistration").replace("{code}",res.data.errorInfo));
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","checkUserRegistration").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "checkUserRegistration", error);
            });
        },
        registerUserToGMOPayment(primaryOwner) {
            let self = this;
            server.post('/gmopaymentsavemember'
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_EXTERNAL_SYSTEM:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_other_system").replace("{functionName}","registerUserToGMOPayment").replace("{code}",res.data.errorInfo));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","registerUserToGMOPayment").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "registerUserToGMOPayment", error);
            });
        },
        handlePurchaseConfirm() {
            let licenseErrorMessage = commonUtil.purchaseLicenseConditionCheck(this.inputForm.license.numberLicense,this.inputForm.license.usageLicense,null,this.$i18n);
            if (licenseErrorMessage != "") {
                commonUtil.notifyMessage(this,"Warning",licenseErrorMessage);
                let obj = document.getElementById("dialog-body");
                obj.scrollTop = obj.scrollHeight;
                return;
            }

            if (Number(this.inputForm.billingType) === constants.BILLING_CREDIT_CARD) {
                this.$refs.creditCardInput.cardInfoValidation();
                if (!this.cardValidation) {
                    return;
                }
                if (commonUtil.isExceedPaymentLimit(this, this.inputForm.purchasePeriodType, this.getPurchaseAmountTotal(this.inputForm.purchasePeriodType))) {
                    return;
                }
                // save credit card information.
                this.$refs.creditCardInput.saveCreditCardInfo();
            } else {
                if (this.paidMemberStatus === constants.PAID_STATUS_NOT_FOUND) {
                    if (!this.$refs.paidInfoInput.validationStatus) {
                        this.$refs.paidInfoInput.inputCheckAll();
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_invalid_company_info_for_paid"));
                        return;
                    } else if (!this.checkPaid) {
                        document.getElementById("paymentMethod").scrollIntoView(true);
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_need_agree_paid"));
                        return;
                    }
                }
                this.showConfirmPurchase();
            }
        },
        purchaseLicense() {
            if (Number(this.purchasePlanType) == constants.LICENSE_PLAN_SEPARATE) {
                this.inputForm.requestType = constants.PURCHASE_REQUEST_NEW;
            } else {
                this.inputForm.requestType = constants.PURCHASE_REQUEST_NEW_PLAN;
            }
            this.$emit('save', this.inputForm);
        },
        saveCardComplete() {
            this.showConfirmPurchase();
        },
        showConfirmPurchase() {
            window.dataLayer.push({
                event: 'FireVirtualPV',
                category: "License",
                "content-name": window.location.pathname,
                "content-view-name": "license_purchase_confirm",
                "license-plan": commonUtil.getPlanName(this.purchasePlanType)
            });
            if ((Number(this.inputForm.billingType) === constants.BILLING_PAID) && (this.paidMemberStatus === constants.PAID_STATUS_NOT_FOUND)) {
                this.inputForm.paidInformation = this.$refs.paidInfoInput.inputForm;
            } else {
                this.inputForm.paidInformation = null;
            }
            this.confirmPurchase = true;
        },
        confirmCancel() {
            this.confirmPurchase = false;
            this.cardValidation = false;
            this.cardSecurityCode = null;
        },
        setNewAmount(license) {
            switch(license.type) {
                case constants.LICENSE_USER:
                case constants.LICENSE_SPEECH_TEXT:
                case constants.LICENSE_TRANSLATION:
                case constants.LICENSE_CONFIG:
                case constants.LICENSE_MAP_TALK:
                case constants.LICENSE_ACCESS_LOG:
                    if (license.newValue > 0) {
                        license.purchaseMonthlyAmount = license.newValue * license.monthlyPrice * (1 + this.appData.taxRate);
                        license.purchaseYearlyAmount = license.newValue * license.yearlyPrice * 12 * (1 + this.appData.taxRate);
                    } else {
                        license.purchaseMonthlyAmount = 0;
                        license.purchaseYearlyAmount = 0;
                    }
                    break;
                case constants.RECURRING_SPEECH_TEXT:
                case constants.RECURRING_TRANSLATION:
                    if (license.newValue > 0) {
                        license.purchaseMonthlyAmount = license.newCount * license.chargePrice * (1 + this.appData.taxRate);
                        license.purchaseYearlyAmount = license.newCount  * license.chargePrice * (1 + this.appData.taxRate);
                    } else {
                        license.purchaseMonthlyAmount = 0;
                        license.purchaseYearlyAmount = 0;
                    }
                    break;
            }
        },
        getPurchaseAmountTotal(periodType) {
            let totalAmount = 0;
            if (this.purchasePlanType == constants.LICENSE_PLAN_SEPARATE) {
                for (let license of this.inputForm.license.numberLicense) {
                    if (periodType == "0") {
                        totalAmount  += license.purchaseMonthlyAmount;
                    } else {
                        totalAmount  += license.purchaseYearlyAmount;
                    }
                }
    //            return totalAmount            // first version not support usage license.

                for (let license of this.inputForm.license.usageLicense) {
                    if (periodType == "0") {
                        totalAmount  += license.purchaseMonthlyAmount;
                    } else {
                        totalAmount  += license.purchaseYearlyAmount;
                    }
                }
            } else {
                totalAmount = this.getPurchasePlanAmount();
            }
            return totalAmount;
        },
        getUnitName(licenseType) {
            return commonUtil.getUnitName(this.$i18n, licenseType);
        },
        getPurchasePeriodTypeName(purchasePeriodType) {
            return commonUtil.getPurchasePeriodTypeName(this.$i18n, purchasePeriodType);
        },
        getDisplayAmountValue(amount) {
            if (this.currencyYen) {
                return Number(amount).toLocaleString();
            } else {
                return Number(amount).toFixed(2).toLocaleString();
            }
        },
        getPurchasePlanName() {
            return commonUtil.getPlanName(this.purchasePlanType);
        },
        getPurchasePlanAmount() {
            if (this.inputForm.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                return this.inputForm.license.numberLicense[0].newValue * this.inputForm.license.numberLicense[0].monthlyPrice * (1 + this.appData.taxRate);
            } else {
                return this.inputForm.license.numberLicense[0].newValue * this.inputForm.license.numberLicense[0].yearlyPrice * 12 * (1 + this.appData.taxRate);
            }
        },
        handleChangeBillingType() {
            if (Number(this.inputForm.billingType) === constants.BILLING_PAID) {
                if (this.appData.countryCodeAlpha3 !== "JPN") {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_paid_cannot_use_tenant"));
                    this.inputForm.billingType = constants.BILLING_CREDIT_CARD.toString();
                } else {
                    if ((this.paidMemberStatus !== constants.PAID_STATUS_ENABLE_IN_USE) && ((this.paidMemberStatus !== constants.PAID_STATUS_NOT_FOUND))) {
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_paid_account_disabled"));
                        this.inputForm.billingType = constants.BILLING_CREDIT_CARD.toString();
                    }
                }
            }
        },
        isCreditPayment() {
            return (this.inputForm.billingType === constants.BILLING_CREDIT_CARD.toString())
        },
        isPaidPayment() {
            return (this.inputForm.billingType === constants.BILLING_PAID.toString())
        },
        isTrial() {
            if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
                return true;
            } else {
                return false;
            }
        },
    },
    components: {
        PaidInfoInput: PaidInfoInput,
        creditcardinput: CreditCardInput,
        confirmlicense: ConfirmLicense,
        ConfirmLicenseForPlanPurchasing: ConfirmLicenseForPlanPurchasing
    },
    created: function() {
        this.inputForm.license = this.licenseInfo;
        let now = new Date();
        this.inputForm.trialExpireDate = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());

        for (let license of this.licenseInfo.numberLicense) {
            this.setNewAmount(license);
        }
        for (let license of this.licenseInfo.usageLicense) {
            this.setNewAmount(license);
        }

        if (this.purchasePlanType != constants.LICENSE_PLAN_SEPARATE) {
            for (let price of this.priceList) {
                if (price.type == this.purchasePlanType) {
                    this.priceOfPlan = price;
                    break;
                }
            }
        }

        return this.checkUserRegistration();
    },
    mounted: function() {
        window.dataLayer.push({
                               event: 'FireVirtualPV',
                               category: "License",
                               "content-name": window.location.pathname,
                               "content-view-name": "license_purchase_paymentinfo_1",
                               "license-plan": commonUtil.getPlanName(this.purchasePlanType)
                           });
        this.creditCardInputComponent = this.$refs.saveCreditCardInfo;
    },
    computed: {
    },
    props: [ 'appData' , 'primaryOwner' , 'licenseInfo' , 'contractInfo' , 'disablePurchasingOption' , 'currencyYen' , 'purchasePlanType' , 'priceList' , 'paidMemberStatus']
}
</script scoped>
<style scoped>

.dialog-description {
    padding: 20px;
}
.dialog-body {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    height: calc(90vh - 230px);
    overflow: auto;
}
.dialog-body-confirm {
    height: calc(90vh - 5px);
}

.credit-card-box {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #f6f6f6;
    width: 520px;
}

.license-item-value >>> .el-input-number {
    width: 160px;
}

.item >>> .el-popper[x-placement^=top] .popper__arrow:after {
    border-top-color: #fff;
}

.item >>> .el-radio__input.is-checked .el-radio__inner {
    background: #5171cb;
}
.item >>> .el-radio__input.is-checked+.el-radio__label {
    color: #5171cb;
}

</style scoped>
